import { useEffect } from 'react';

import { usePlayerConfiguration } from '@kaltura-ott/tvpil-shared'

import { ROOT } from 'consts';
import { applyStyle } from 'utils';

function usePlayerSettings() {
  const configuration = usePlayerConfiguration();
  const rootEl = document.getElementById(ROOT) as HTMLElement;

  useEffect(() => {
    if (configuration && rootEl) {
      applyStyle(rootEl, '--font-size-basic', `${configuration.subtitlesBaseFontSize}px`);
    }
  }, [configuration]);

}

export { usePlayerSettings };
